"use client";

import { createContext, useContext, useState } from "react";

export const AddVenueContext = createContext({
  venueDatas: {
    name: "",
    address: "",
    firstname: "",
    lastname: "",
    phone: "",
  },
  setVenueDatas: (bn: any) => { },
});

export const AddVenueProvider = ({ children }: any) => {
  const [venueDatas, setVenueDatas] = useState({
    name: "",
    address: "",
    firstname: "",
    lastname: "",
    phone: "",
  } as any);

  const value = {
    venueDatas,
    setVenueDatas,
  };

  return (
    <AddVenueContext.Provider value={value}>
      {children}
    </AddVenueContext.Provider>
  );
};

export const useAddVenueContext = () => {
  return useContext(AddVenueContext);
};
